export const RouterConfig = [
	{
		path: '/',
		component: require('./pages/Login'),
		meta: {
			title: '系统登录'
		}
	},
	{
		path: '/forgot',
		component: require('./pages/Forgot'),
		meta: {
			title: '密码找回'
		}
	},
	{
		path: '/mobile-bind',
		component: require('./pages/MobileBind'),
		meta: {
			title: '手机绑定'
		}
	},
	{
		path: '/email-bind',
		component: require('./pages/EmailBind'),
		meta: {
			title: '邮箱绑定'
		}
	},
	{
		path: '/mobile-check',
		component: require('./pages/MobileCheck'),
		meta: {
			title: '手机验证'
		}
	},
	{
		path: '/password-modify',
		component: require('./pages/PasswordModify'),
		meta: {
			title: '忘记密码'
		}
	},
	{
		path: '/password-modifym',
		component: require('./pages/PasswordModifyM'),
		meta: {
			title: '密码修改'
		}
	},
	{
		path: '/register',
		component: require('./pages/Register'),
		meta: {
			title: '新用户注册'
		}
	},
	{
		path: '/all-order-bill',
		component: require('./pages/AllOrderBill'),
		meta: {
			title: '餐企订单-全部'
		}
	},
	{
		path: '/all-return-bill',
		component: require('./pages/AllReturnBill'),
		meta: {
			title: '餐企退单-全部'
		}
	},
	{
		path: '/quotation-bill',
		component: require('./pages/QuotationBill'),
		meta: {
			title: '餐企报价单-全部'
		}
	},
	{
		path: '/account-check-bill',
		component: require('./pages/AccountCheckBill'),
		meta: {
			title: '餐企对账单-全部'
		}
	},
	{
		path: '/supplier-account-check-bill',
		component: require('./pages/SupplierAccountCheckBill'),
		meta: {
			title: '餐企对账单-全部'
		}
	},
	{
		path: '/supplier-account-check-detail-bill',
		component: require('./pages/SupplierAccountCheckDetailBill'),
		meta: {
			title: '餐企对账单-明细'
		}
	},
	{
		path: '/bill-count',
		component: require('./pages/BillCount'),
		meta: {
			title: '单据统计-餐企'
		}
	},
	{
		path: '/bill-count-detail',
		component: require('./pages/BillCountDetail'),
		meta: {
			title: '单据统计-明细'
		}
	},
	{
		path: '/bill-count-serial',
		component: require('./pages/BillCountSerial'),
		meta: {
			title: '单据统计-单据流水'
		}
	},
	{
		path: '/bill-count-serial-detail',
		component: require('./pages/BillCountSerialDetail'),
		meta: {
			title: '单据统计-流水明细'
		}
	},
	{
		path: '/detail-bill',
		name: 'detail-bill',
		component: require('./pages/DetailBill'),
		meta: {
			title: '餐企订单-明细'
		}
	},
	{
		path: '/detail-bill-1',
		component: require('./pages/DetailBillFirst'),
		meta: {
			title: '餐企订单-明细'
		}
	},
	{
		path: '/detail-bill-edit',
		component: require('./pages/DetailBillFirstEdit'),
		meta: {
			title: '餐企订单-明细编辑'
		}
	},
	{
		path: '/detail-return-bill',
		component: require('./pages/DetailReturnBill'),
		meta: {
			title: '餐企退单-明细'
		}
	},
	{
		path: '/detail-quotation-bill',
		name: 'detail-bill',
		component: require('./pages/QuotationDetailBill'),
		meta: {
			title: '餐企报价单-明细'
		}
	},
	{
		path: '/detail-quotation-edit',
		component: require('./pages/QuotationDetailEdit'),
		meta: {
			title: '餐企报价单-明细编辑'
		}
	},
	{
		path: '/inquiry-price-bill',
		component: require('./pages/InquiryPriceBill'),
		meta: {
			title: '餐企询价单-全部'
		}
	},
	{
		path: '/detail-inquiry-price-bill',
		name: 'detail-bill',
		component: require('./pages/InquiryPriceDetailBill'),
		meta: {
			title: '餐企询价单-明细'
		}
	},
	{
		path: '/detail-inquiry-price-edit',
		component: require('./pages/InquiryPriceDetailEdit'),
		meta: {
			title: '餐企询价单-明细编辑'
		}
	},
	{
		path: '/account-check-detail-bill',
		component: require('./pages/AccountCheckDetailBill'),
		meta: {
			title: '餐企对账单-明细'
		}
	},
	{
		path: '/main',
		component: require('./pages/Main'),
		meta: {
			title: '天财商龙供货商EDI'
		},
		children: [
			{
				path: 'home',
				component: require('./pages/Home'),
				meta: {
					title: '首页'
				}
			},
			{
				path: 'reciept',
				component: require('./pages/Reciept'),
				meta: {
					title: '单据'
				}
			},
			{
				path: 'my',
				component: require('./pages/My'),
				meta: {
					title: '我的'
				}
			}
		]
	},
	{
		path: '/accounts',
		component: require('./pages/Accounts'),
		meta: {
			title: '账号安全'
		}
	},
	{
		path: '/infomation',
		component: require('./pages/Infomation'),
		meta: {
			title: '企业资料'
		}
	},
	{
		path: '/help',
		component: require('./pages/Help'),
		meta: {
			title: '帮助'
		}
	},
	{
		path: '/version',
		component: require('./pages/Version'),
		meta: {
			title: '版本信息'
		}
	},
	{
		path: '/email',
		component: require('./pages/Email'),
		meta: {
			title: '邮箱信息'
		}
	},
	{
		path: '/mobile',
		component: require('./pages/Mobile'),
		meta: {
			title: '手机信息'
		}
	},
	{
		path: '/goods-company-summary',
		component: require('./pages/GoodsCompanySummary'),
		meta: {
			title: '货品汇总-餐企'
		}
	},
	{
		path: '/goods-money-summary',
		component: require('./pages/GoodsMoneySummary'),
		meta: {
			title: '金额汇总-餐企'
		}
	},
	{
		path: '/goods-organ-summary',
		component: require('./pages/GoodsOrganSummary'),
		meta: {
			title: '货品汇总-机构'
		}
	},
	{
		path: '/paper-manager',
		component: require('./pages/PaperManager'),
		meta: {
			title: '证照管理'
		}
	},
	{
		path: '/paper-detail',
		component: require('./pages/paper-detail/PaperDetail'),
		meta: {
			title: '证照明细'
		}
	},

	{
		path: '/send-info',
		component: require('./pages/SendInfo'),
		meta: {
			title: '送货信息'
		}
	},
	{
		path: '/system-parameter',
		component: require('./pages/SystemParameter'),
		meta: {
			title: '系统参数'
		}
	},
	{
		path: '*',
		component: require('./pages/NotFound'),
		meta: {
			title: '页面已过期'
		}
	}
]



// WEBPACK FOOTER //
// ./src/RouterConfig.js